import React from 'react';
import { TableHead, TableRow, TableCell, Typography } from '@mui/material';

interface TableColumnHeadersProps {
  columns: string[];
}

const TableColumnHeaders: React.FC<TableColumnHeadersProps> = ({ columns }) => {
  return (
    <TableHead>
      <TableRow className='user-accounts'>
        <TableCell
          variant='head'
          sx={{ borderBottom: 'none', width: 0, paddingTop: 0, paddingBottom: 0 }}>
          &nbsp;
        </TableCell>
        <TableCell variant='head' sx={{ borderBottom: 'none', paddingTop: 0, paddingBottom: 0 }}>
          &nbsp;
        </TableCell>

        {columns.map(col => (
          <TableCell
            key={col}
            variant='head'
            sx={{
              borderBottom: 'none',
              textAlign: 'right',
              paddingTop: 0,
              paddingBottom: 1,
              whiteSpace: 'nowrap',
            }}>
            <Typography variant={col === 'Total' ? 'p16Bold' : 'p16Light'} color='secondary.dark'>
              {col}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableColumnHeaders;
